<template>
    <div class="box">
        <div class="v_header flexCenter" ref="getheight1">
            <span class="headline mr42">修改日志</span>
            <el-button class="input_button" size="mini" @click="getExport">导出</el-button>
        </div>
        <el-table :data="message" :max-height="height + 'px'" style="width: 100%">
            <el-table-column fixed="" label="时间" width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    {{ scope.row.created_on | formatOrdertime }}
                </template>
            </el-table-column>
            <el-table-column prop="email" label="操作人" width="180" :render-header="renderPrice"> </el-table-column>
            <el-table-column label="修改内容" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.content" placement="bottom">
                        <span class="v_tips">{{ scope.row.content }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title">{{ msg }}</div>
            </div>
        </div>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
export default {
    name: 'record',
    data() {
        return {
            msg: '',
            notificationns: false,
            page: {
                num: 10,
                page: 1,
                total: 0
            },
            message: [],
            height: ''
        };
    },

    mounted() {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight1.offsetHeight - 85 - 24 - 40;

        this.getMessage();
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num
            };
            that.$get('/backapi/modify_log', obj).then(function (res) {
                if (res.count) {
                    that.page.total = res.count;
                    that.message = res.data;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        // 导出
        getExport() {
            let that = this;
            if (that.page.total == 0) {
                // that.$message({
                //     message: '暂无数据导出',
                //     type: 'warning'
                // });
                (that.msg = '暂无数据导出'), (that.notificationns = true);
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }
            let obj = {
                page: 1,
                num: that.page.total,
                is_download: true
            };
            that.$get('/backapi/modify_log', obj).then(function (res) {
               

                if (res.code == 200) {
                    (that.msg = '数据导出成功'), (that.notificationns = true);
                    setTimeout(() => {
                        that.notificationns = false;
                    }, 3000);
                    // if (res.data.length != 0 && res.data) {
                    //     const fdArray = [];
                    // res.data.forEach(function (item, index) {
                    //     var obj = {
                    //         时间: that.$formatOrdertime(item.created_on),
                    //         操作人: item.email,
                    //         修改内容: item.content
                    //     };
                    //     fdArray.push(obj);
                    // });
                    // var wb = XLSX.utils.book_new();
                    // let sheet = XLSX.utils.json_to_sheet(fdArray);
                    // sheet['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 40 }];
                    // XLSX.utils.book_append_sheet(wb, sheet, 'sheet', { raw: true });
                    // XLSX.writeFile(wb, '修改日志 - 数据列表' + '.xlsx');
                    // that.$message({
                    //     message: '数据导出成功',
                    //     type: 'success'
                    // });
                    //     that.msg='数据导出成功',
                    //     that.notificationns = true;
                    //     setTimeout(() => {
                    //         that.notificationns = false;
                    //     }, 3000);
                    // } else {

                    //     that.msg='暂无数据导出',
                    //     that.notificationns = true;
                    //     setTimeout(() => {
                    //         that.notificationns = false;
                    //     }, 3000);
                    // }
                } else {
                    // that.$message({
                    //     message: '暂无数据导出',
                    //     type: 'warning'
                    // });
                    (that.msg = '导出失败'), (that.notificationns = true);
                    setTimeout(() => {
                        that.notificationns = false;
                    }, 3000);
                }
            });
        }
    }
};
</script>

<style scoped>
.v_header {
    justify-content: space-between;
    margin-bottom: 24px;
}
/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}
</style>
